
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invite-friends",
      function () {
        return require("private-next-pages/invite-friends.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invite-friends"])
      });
    }
  